module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "thank_you.cd0160fe.png";